<div class="main_title">
  <h3>Traveller Information</h3>
</div>
<mat-card class="matCard_wrapper travellerDetails">
  <ul>
    <li *ngFor="let room of Passanger_details; let i = index">
      <h4>Room {{ i + 1 }}</h4>
      <div *ngFor="let adult of room.adult">
        <p>{{ adult.first_name }} {{ adult.last_name }}&nbsp;<span>(Adult)</span></p>
      </div>
      <div *ngFor="let child of room.child">
        <p>{{ child.first_name }} {{ child.last_name }}&nbsp;<span>(Child)</span></p>
      </div>
    </li>
  </ul>
</mat-card>
<div class="main_title">
  <h3>Payment Methods</h3>
</div>
<mat-card class="paymentCardDesign">
  <mat-tab-group dynamicHeight class="paymentIndex" animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tabBtn">
          <img src="../../../assets/main/credit-card.png" alt="Credit/Debit Card" class="img-fluid">
          <p>Credit/Debit Card</p>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <!-- Credit Debit Card -->
        <div class="tabWrapper cardDesign">
          <div class="paymentHeader">
            <h3 class="titleHeading">Pay Using Credit/Debit Card</h3>
            <div class="gstDetails">
              <button mat-button class="gstBtn" (click)="gstInfo()" *ngIf="list.length < 1"><mat-icon>add</mat-icon>Add GST</button>
              <p *ngIf="list.length > 0">
                <ng-container *ngFor="let item of list">
                  <span (click)="gstEdit()">{{item.GSTNumber}}</span>
                  <button mat-icon-button color="primary" (click)="removeList(item)"><mat-icon>close</mat-icon></button>
                </ng-container>
              </p>
            </div>
          </div>
          <p class="importantNotice">
            <mat-icon color="warn">priority_high</mat-icon><span>IMPORTANT:&nbsp;The charge will appear on your
            credit card / account statement as&nbsp;<strong>“Airtickets India Pvt. Ltd”</strong></span>
          </p>
          <div class="row wrapper">
            <div class="innerWrapper">
              <form [formGroup]="paymentForm">
                <mat-card class="formCard">
                  <ng-container *ngIf="type$ | async as type">
                    <mat-form-field appearance="outline" color="primary" hidden class="col-md-12"
                      *ngIf="type === 'mastercard'">
                      <mat-label>Credit/Debit Card</mat-label>
                      <input matInput placeholder="Credit/Debit Card" formControlName="card_type" [(ngModel)]="mastercard" maxlength="16" minlength="16">
                    </mat-form-field>
                  </ng-container>
                  <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
                    <mat-label>Credit/Debit Number`</mat-label>
                    <img matSuffix src="../../../assets/bank_icon/error_payment.png" alt="Credit/Debit Card" class="img-fluid" onerror="this.src='../../../assets/bank_icon/error_payment.png';">
                    <input matInput placeholder="Enter your Credit/Debit Card Number" formControlName="card_number" maxlength="16" minlength="16">
                    <mat-error *ngIf="paymentForm.controls['card_number'].hasError('required')"><strong>Credit/Debit Card</strong> is required.</mat-error>
                  </mat-form-field>
                  <div class="col-md-12">
                    <div class="row">
                      <mat-form-field appearance="outline" color="primary" class="col-md-3" floatLabel="always">
                        <mat-label>Month (MM)</mat-label>
                        <mat-select matInput placeholder="Enter your Month" formControlName="card_exp_month">
                          <mat-option *ngFor="let item of month" [value]="item.value">{{item.value}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="paymentForm.controls['card_exp_month'].hasError('required')"><strong>Month</strong> is required.</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" color="primary" class="col-md-5" floatLabel="always">
                        <mat-label>Year (YYYY)</mat-label>
                        <mat-select matInput placeholder="Enter your Year" formControlName="card_exp_year">
                          <mat-option *ngFor="let item of year" [value]="item">{{item}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="paymentForm.controls['card_exp_year'].hasError('required')"><strong>Year</strong> is required.</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" color="primary" class="col-md-4" floatLabel="always">
                        <mat-label>CVV</mat-label>
                        <input matInput placeholder="CVV" formControlName="card_cvv" maxlength="3" minlength="3">
                        <mat-error *ngIf="paymentForm.controls['card_cvv'].hasError('required')"><strong>CVV</strong> is required.</mat-error>
                        <mat-hint>CVV</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <mat-form-field appearance="outline" color="primary" class="col-md-12">
                    <mat-label>Name on Card</mat-label>
                    <input matInput placeholder="Enter your Name on card" formControlName="card_holder_name" maxlength="25">
                    <mat-error *ngIf="paymentForm.controls['card_holder_name'].hasError('required')"><strong>Name on card</strong> is required.</mat-error>
                  </mat-form-field>
                  <div class="amount_total">
                    <p class="totalamt">Total Amount: <span>{{totalRoomPrice}}</span></p>
                  </div>
                  <!-- <p><mat-checkbox [formControl]="saveCard" value="" color="primary">Save card details</mat-checkbox></p> -->
                  <p> <mat-checkbox formControlName="termsServices" color="primary" [(ngModel)]="checked">I have read and accepted the <a class="linkColor">Terms of Services*</a></mat-checkbox></p>
                    <!-- <p class="totalAmmount">Total Amount: &nbsp;&nbsp;&nbsp;&nbsp;<span>{{this.rP.total_price * this.ROOM + this.rP.tax - this.rP.discount | currency: 'INR'}}</span></p> -->
                    <button mat-button (click)="paymentNow()" class="secoundaryBtn">Payment Now</button>
                </mat-card>
              </form>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <!-- Netbanking -->
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tabBtn">
          <img src="../../../assets/main/mobile-banking.png" alt="Internet Banking" class="img-fluid"><br>
          <p>Net Banking</p>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tabWrapper netBankingDesign">
          <div class="paymentHeader">
            <h3 class="titleHeading">Pay Using Net Banking</h3>
            <div class="gstDetails">
              <button mat-button class="gstBtn" (click)="gstInfo()" *ngIf="list.length < 1"><mat-icon>add</mat-icon>Add GST</button>
              <p *ngIf="list.length > 0">
                <ng-container *ngFor="let item of list">
                  <span (click)="gstEdit()">{{item.GSTNumber}}</span>
                  <button mat-icon-button color="primary" (click)="removeList(item)"><mat-icon>close</mat-icon></button>
                </ng-container>
              </p>
            </div>
          </div>
          <p class="importantNotice">
            <mat-icon color="warn">priority_high</mat-icon><span>IMPORTANT:&nbsp;The charge will appear on your
            credit card / account statement as&nbsp;<strong>“Airtickets India Pvt. Ltd”</strong></span>
          </p>
          <div class="wrapper">
            <form [formGroup]="net_banking_Payment">

              <div class="innerWrapper">
                <div class="cardWrapper">
                  <!-- internet banking system -->
                  <mat-form-field appearance="outline" floatLabel="always" class="w-75">
                    <mat-label>Select Net Banking</mat-label>
                    <input matInput placeholder="Select your Net Banking" [formControl]="net_banking_value" [(ngModel)]="term" [value]="selectedBank">
                    <mat-error *ngIf="net_banking_value.hasError('required')"><strong>Select Net Banking</strong> is required.</mat-error>
                  </mat-form-field>
                  <div class="payment_list">
                    <mat-radio-group>
                      <mat-radio-button *ngFor="let item of internet_banking_  | filter: term ; let i = index" color="primary" [value]="item" (click)="select(item)" (change)="onRadioChange($event)">
                        <div class="paymentwrap">
                          <img [src]="item.logo" [alt]="item.name" class="img-fluid" onerror="this.src='../../../assets/main/payment_dummy.png'">&nbsp;&nbsp;<span>{{item.name}}</span>
                        </div>
                      </mat-radio-button>
                    </mat-radio-group>
                    <div class="noResult" *ngIf="(bank_list_.net_banking | filter: term).length === 0">
                      <img src="../../../assets/main/debt.png" alt="Not Found">
                      <h4>No results found.</h4>
                    </div>
                  </div>
                </div>
                <div class="amount_total">
                  <!-- <p *ngIf="this.conv_fee_internetBank">Convenience Fee:&nbsp;<span>
                    <ng-container *ngIf="this.conv_fee_internetBank.per_passenger === 0">
                      {{this.conv_fee_internetBank.per_passenger + this.conv_fee_internetBank.pymtConvFee | currency:list__.currency}}
                    </ng-container>
                    <ng-container *ngIf="this.conv_fee_internetBank.per_passenger !== 0">
                      {{this.conv_fee_internetBank.per_passenger | currency:list__.currency}}
                    </ng-container>
                  </span></p> -->
                  <p class="totalamt">Total Amount: <span>{{totalRoomPrice}}
                  </span></p>
                  <mat-checkbox color="primary" [formControl]="internet_tearm_condition" [(ngModel)]="internet_disabled" [checked]="true"> I have read and accepted the <a href="./t&c" target="_blank">Terms of Services<sup>*</sup></a></mat-checkbox>
                  <p class="error_msg" *ngIf="!internet_disabled">Please select Terms and Condition.</p>
                </div>
                <div class="messageArea w-100">
                  <p class="denger">{{this.errMsg}}</p>
                </div>
                <button class="secoundaryBtn" mat-button [disabled]="!internet_disabled" (click)="internet_Banking_payment()">Payment Now</button>
              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </mat-tab>

    <!-- Wallets -->
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tabBtn">
          <img src="../../../assets/main/wallet.png" alt="Wallets" class="img-fluid"><br>
          <p>Wallets</p>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tabWrapper upiDesign">
          <div class="paymentHeader">
            <h3 class="titleHeading">Pay Using Wallets</h3>
            <div class="gstDetails">
              <button mat-button class="gstBtn" (click)="gstInfo()" *ngIf="list.length < 1"><mat-icon>add</mat-icon>Add GST</button>
              <p *ngIf="list.length > 0">
                <ng-container *ngFor="let item of list">
                  <span (click)="gstEdit()">{{item.GSTNumber}}</span>
                  <button mat-icon-button color="primary" (click)="removeList(item)"><mat-icon>close</mat-icon></button>
                </ng-container>
              </p>
            </div>
          </div>
          <p class="importantNotice">
            <mat-icon color="warn">priority_high</mat-icon><span>IMPORTANT:&nbsp;The charge will appear on your
            credit card / account statement as&nbsp;<strong>“Airtickets India Pvt. Ltd”</strong></span>
          </p>
          <div class="wrapper">
            <form [formGroup]="walletsPayment">
              <div class="innerWrapper">
                <div class="cardWrapper">
                  <!-- Wallet banking system -->
                  <mat-form-field appearance="outline" floatLabel="always" class="w-75">
                    <mat-label>Select Wallet</mat-label>
                    <input matInput placeholder="Select your wallet Banking" [formControl]="wallets_banking_value" [value]="selectedWallet" >
                    <mat-error *ngIf="wallets_banking_value.hasError('required')"><strong>Select Wallet Banking</strong> is required.</mat-error>
                  </mat-form-field>
                  <div class="payment_list">
                    <mat-radio-group [(ngModel)]="selectedWalletItem">
                      <mat-radio-button *ngFor="let item of wallet | filter: term ; let i = index" color="primary" [value]="item"  (click)="selectWalletBanking(item)" (change)="onRadiowalletChange($event)">
                        <div class="paymentwrap">
                          <img [src]="item.logo" [alt]="item.name" class="img-fluid" onerror="this.src='../../../assets/main/payment_dummy.png'">&nbsp;&nbsp;<span>{{item.name}}</span>
                        </div>
                      </mat-radio-button>
                    </mat-radio-group>
                    <div class="noResult" *ngIf="(wallet | filter: term).length === 0">
                      <img src="../../../assets/main/debt.png" alt="Not Found">
                      <h4>No results found.</h4>
                    </div>
                  </div>
                </div>
                <div class="amount_total">
                  <p class="totalamt">Total Amount: <span>{{totalRoomPrice}}</span></p>
                  <mat-checkbox color="primary" [formControl]="test_tearm_condition" [(ngModel)]="wallets_disabled" [checked]="true"> I have read and accepted the <a href="./t&c" target="_blank">Terms of Services<sup>*</sup></a></mat-checkbox>
                  <p class="error_msg" *ngIf="!wallets_disabled">Please select Terms and Condition.</p>
                </div>
                <div class="messageArea">
                  <p class="denger">{{this.errMsg}}</p>
                </div>
                <button class="secoundaryBtn" mat-button [disabled]="!wallets_disabled" (click)="wallets_Banking_payment()">Payment Now</button>
              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <!-- Upi -->
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tabBtn">
          <img src="../../../assets/main/upi.png" alt="Upi" class="img-fluid"><br>
          <p>UPI</p>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tabWrapper walletsDesign">
          <div class="paymentHeader">
            <h3 class="titleHeading">Pay Using UPI</h3>
            <div class="gstDetails">
              <button mat-button class="gstBtn" (click)="gstInfo()" *ngIf="list.length < 1"><mat-icon>add</mat-icon>Add GST</button>
              <p *ngIf="list.length > 0">
                <ng-container *ngFor="let item of list">
                  <span (click)="gstEdit()">{{item.GSTNumber}}</span>
                  <button mat-icon-button color="primary" (click)="removeList(item)"><mat-icon>close</mat-icon></button>
                </ng-container>
              </p>
            </div>
          </div>
          <p class="importantNotice">
            <mat-icon color="warn">priority_high</mat-icon><span>IMPORTANT:&nbsp;The charge will appear on your
            credit card / account statement as&nbsp;<strong>“Airtickets India Pvt. Ltd”</strong></span>
          </p>
          <div class="wrapper">
            <form [formGroup]="upiPayment">
              <div class="innerWrapper">
                <section class="upi_section">
                  <div class="wrapperInner scan_wapper">
                    <h4>Scan & Pay</h4>
                    <div class="scan_img">
                      <img src="../../../../assets/main/bank_logo/upi_qr_code.jpg" alt="Scan and pay" class="img-fluid">
                      <button mat-button class="view_qr_code" (click)="view_qr_code()">View</button>
                    </div>
                    <p>Scan and pay using any Banking App</p>
                  </div>
                  <div class="wrapperInner or_UPI"><p>OR</p></div>
                  <div class="wrapperInner">
                    <h4>Enter UPI ID</h4>
                    <mat-form-field appearance="outline" floatLabel="always" color="primary" class="col-md-12">
                      <mat-label>Enter your UPI Id</mat-label>
                      <input matInput placeholder="Enter your UPI Id" [formControl]="upi_banking_number">
                      <mat-error *ngIf="upi_banking_number.hasError('required')"><strong>UPI Id</strong> is required.</mat-error>
                    </mat-form-field>
                    <button mat-button color="primary" (click)="verify_pay()" class="verify_pay_btn">Verify & Pay</button>
                    <div class="more_information">
                      <ul>
                        <li>Enter your registered VPA.</li>
                        <li>Receive payment request on bank app.</li>
                        <li>Authorize payment request.</li>
                      </ul>
                    </div>
                  </div>
                </section>
                <div class="amount_total">
                  <p class="totalamt">Total Amount: <span>{{totalRoomPrice}}</span></p>
                  <mat-checkbox color="primary" [formControl]="test_tearm_condition" [(ngModel)]="checkedUpi" [checked]="true"> I have read and accepted the <a href="./t&c" target="_blank">Terms of Services<sup>*</sup></a></mat-checkbox>
                  <p class="error_msg" *ngIf="!checkedUpi">Please select Terms and Condition.</p>
                </div>
                <div class="messageArea">
                  <p class="denger">{{this.errMsg}}</p>
                </div>
                <button class="secoundaryBtn" mat-button [disabled]="!checkedUpi" (click)="wallets_Banking_payment()">Payment Now</button>
              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-card>
<mat-card class="paymentLogo">
  <ul>
    <li><img src="../../../assets/main/verified_by_visa.svg" alt="" class="img-fluid"></li>
    <li><img src="../../../assets/main/mc_seccode.svg" alt="" class="img-fluid"></li>
    <li><img src="../../../assets/main/safeKey.svg" alt="" class="img-fluid"></li>
    <li><img src="../../../assets/main/ssl-certificate-seal-from-srn-hosting.svg" alt="" class="img-fluid"></li>
    <li><img src="../../../assets/main/credibility_pci.svg" alt="" class="img-fluid"></li>
    <li><img src="../../../assets/main/ruPay.svg" alt="" class="img-fluid"></li>
  </ul>
</mat-card>
